import { NormalizedTask } from '@opallabs/wormhole/types'

interface PhaseItemPatchParams {
  data: {
    id: string | number
    type: 'phase_item'
    attributes: {
      is_starred?: boolean
      status?: 'incomplete' | 'complete'
    }
  }
}
export const togglePhaseItemStarredTaskParams = (
  task: NormalizedTask
): PhaseItemPatchParams => ({
  data: {
    id: task.id,
    type: 'phase_item',
    attributes: {
      is_starred: !task.starred, // flip is_starred based on task.starred
    },
  },
})

export const togglePhaseItemCompleteTaskParams = (
  task: NormalizedTask
): PhaseItemPatchParams => ({
  data: {
    id: task.id,
    type: 'phase_item',
    attributes: {
      status: task.checked ? 'incomplete' : 'complete', // flip complete based on task.checked
    },
  },
})

interface AssignmentPatchParams {
  id: string | number
  attributes: {
    metadata: {
      is_starred: boolean
    }
  }
}

export const toggleAssignmentStarredTaskParams = (
  task: NormalizedTask
): AssignmentPatchParams => ({
  id: task.id,
  attributes: {
    metadata: {
      is_starred: !task.starred, // flip is_starred based on task.starred
    },
  },
})

interface ResponsePostParams {
  assignmentId: string | number
  details: {
    complete: boolean
  }
  view: string
}

export const toggleAssignmentCompleteTaskParams = (
  task: NormalizedTask
): ResponsePostParams => ({
  assignmentId: task.id,
  details: {
    complete: !task.checked, // flip complete based on task.checked
  },
  view: 'personalPanel',
})
